import React from "react";
import { Row, Container, Col, Card, CardBody, Modal, ModalBody } from "reactstrap";

import "./Getcertificate.css";
import $ from "jquery";
import HubspotForm from "react-hubspot-form";
import Calendar from "../Calendar/Calendar";

export default class Getcertificate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      condition: 'first',
      title: "Find a certification session",
      currency: "EUR"
    };

    this.toggle = this.toggle.bind(this);
    this.handleClick = this.handleClick.bind(this);

  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
    setTimeout(function () {
      var large =
        '<span class="tooltip1">Terms and Conditions<span class="tooltiptext1">Certified Integrator is committed to protecting and respecting your privacy, and we’ll only use your personal information to administer your account and to provide the products and services you requested from us. From time to time, we would like to contact you about our products and services, as well as other content that may be of interest to you. If you consent to us contacting you for this purpose, please tick below to say how you would like us to contact you:<br> By clicking submit below, you consent to allow Certified Integrator to store and process the personal information submitted above to provide you the content requested.<br>I agree to allow Certified Integrator to store and process my personal data.</span></span>';

      $(large).insertAfter(
        "#reactHubspotForm1 .hs-form-booleancheckbox label span span"
      );
    }, 7000);
  }

  handleClick(id) {
    const clicked = id
    if (!this.state.condition === clicked) {
      this.setState({ condition: '' });
    } else {
      this.setState({ condition: clicked })
    }
  }

  currencyChanger(type) {
    this.setState({
      currency: type
    })
  }

  componentDidMount() { }
  render() {
    return (
      <Container className="certificate-container">
        <div className="how-work-block d-md-block">
          <h3 className="text-center">How does it work?</h3>
          <div className="row">
            <Col md="4" className="hwb-box">
              <img
                src={require("../../img/logo-icon.png")}
                alt="integrator"
                className="img-fluid hwb-img"
              />
              <h4>Certification sessions</h4>
              <p className="small-text">
                Certified Integrator is available as a full day learning session
                together with the certification exam and as certification exam
                only (for renewal).
              </p>
            </Col>
            <Col md="4" className="hwb-box">
              <img
                src={require("../../img/mic.png")}
                alt="integrator"
                className="img-fluid hwb-img"
              />
              <h4>Online & Onsite</h4>
              <p className="small-text">
                Certification sessions are available on a regular basis, both
                online and in different countries and cities. Check the calendar
                below for a session.
              </p>
            </Col>
            <Col md="4" className="hwb-box">
              <img
                src={require("../../img/clock.png")}
                alt="integrator"
                className="img-fluid hwb-img"
              />
              <h4>Valid for two-years</h4>
              <p className="small-text">
                The Certified Integrator are valid for two years. We’ll contact
                you when it is time for renewal.
              </p>
            </Col>
          </div>
        </div>
        <Calendar title={this.state.title} />
        <Row className="price-block same-height">
          <Col md="4" className="price-list">
            <h2>Prices</h2>
            <p className="grey">Get an all new certification <br />or renew your current.</p>
          </Col>

          <Col md="4" className={this.state.condition === "first" ? 'price-list main' : 'price-list'} onClick={() => this.handleClick('first')}>
            <div className="currency_switch">
              <span className={this.state.currency === "EUR" ? "active" : ""} onClick={()=>{this.currencyChanger("EUR")}}>EUR</span>
              <span className={this.state.currency === "SEK" ? "active" : ""} onClick={()=>{this.currencyChanger("SEK")}}>SEK</span>
            </div>
            <h1 className="text-center">{this.state.currency === "EUR" ? "€950" : "9.900 KR" }</h1>
            <p className="text-center smallest-text white">FULL DAY <br />CERTIFIED INTEGRATOR</p>
            <ul>
              <li className="smallest-text">Full day lessons<span></span></li>
              <li className="smallest-text">Case Study<span></span></li>
              <li className="smallest-text">Examination<span></span></li>
              <li className="smallest-text">Two-year certificate<span></span></li>
            </ul>
            {this.state.condition === "first" ? <a href="#getcertified" className="int-btn blue-btn">SCHEDULE</a> : ''}
          </Col>

          <Col md="4" className={this.state.condition === "second" ? 'price-list main' : 'price-list'} onClick={() => this.handleClick('second')}>
            <div className="currency_switch">
              <span className={this.state.currency === "EUR" ? "active" : ""} onClick={()=>{this.currencyChanger("EUR")}}>EUR</span>
              <span className={this.state.currency === "SEK" ? "active" : ""} onClick={()=>{this.currencyChanger("SEK")}}>SEK</span>
            </div>
            <h1 className="text-center">{this.state.currency === "EUR" ? "€450" : "4.900 KR" }</h1>
            <p className="text-center smallest-text white">CERTIFICATION  <br />ONLY</p>
            <ul>
              <li className="smallest-text">Case Study<span></span></li>
              <li className="smallest-text">Examination<span></span></li>
              <li className="smallest-text">Two-year certificate<span></span></li>
            </ul>
            {this.state.condition === "second" ? <a href="#getcertified" className="int-btn blue-btn">SCHEDULE</a> : ''}
          </Col>
        </Row>
        <div className="faq-block">
          <h3 className="text-center">Frequently Asked Questions</h3>
          <div className="row faq-items">
            <div className="col-sm faq-item">
              <ul>
                <li className="question">
                  <span>Q</span>
                  <p> Why should I get certified?</p>
                </li>
                <li className="answer">
                  <span>A</span>
                  <p>
                    Stay up-to-date on the best practices ways for end-to-end
                    integration landscapes.
                  </p>
                </li>
              </ul>
            </div>
            <div className="col-sm faq-item">
              <ul>
                <li className="question">
                  <span>Q</span>
                  <p>
                    What is the difference between full day certification and certification only?
                  </p>
                </li>
                <li className="answer">
                  <span>A</span>
                  <p>
                    The full day includes the lesson session which gives you the required knowledge of the 15 essentials of the certification. The certification only option contains only of the certification part.
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <div className="row faq-items">
            <div className="col-sm faq-item">
              <ul>
                <li className="question">
                  <span>Q</span>
                  <p>For how long is the certificate valid?</p>
                </li>
                <li className="answer">
                  <span>A</span>
                  <p>
                    The Certified Integrator are valid for two years.
                  </p>
                </li>
              </ul>
            </div>
            <div className="col-sm faq-item">
              <ul>
                <li className="question">
                  <span>Q</span>
                  <p> Can I study by myself?</p>
                </li>
                <li className="answer">
                  <span>A</span>
                  <p>
                    Yes, if you feel comfortable with the parts of the
                    certification, you can study by your own and doing the
                    certification only.
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <Card className="col-md-10 offset-md-1 crt-box-block">
          <CardBody className="row">
            <Col md="6">
              <p>
                Can't find answer? Don’t worry, our support team will help you
              </p>
            </Col>
            <Col
              md="6"
              className="align-self-center justify-content-center d-flex"
            >
              <button className="int-btn blue-btn" onClick={this.toggle}>
                CONTACT US
              </button>
            </Col>
          </CardBody>
        </Card>
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle}
          className={this.props.className}
          id="contact"
        >
          <h3 className="text-center">Contact us</h3>
          <p className="text-center">
            Fill out the form and we will get back to you as soon as possible
          </p>
          <ModalBody>
            <HubspotForm
              portalId="2277117"
              formId="546915cb-10a6-4431-9aa4-1a8802dccc87"
              onSubmit={() => console.log("Submit!")}
              onReady={form => console.log("Form ready!")}
              loading={<div>Loading...</div>}
            />
          </ModalBody>
        </Modal>
      </Container >
    );
  }
}
